import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { APP_CONFIG } from 'app-config';
import { AlertService } from './alert.service';
import { LiquidityBotRequest, LiquidityBotRequestConditional } from '../model';
import {
  LiquidityBotRequestConditionalDto,
  LiquidityBotRequestDto,
} from '../dto';
import { IsLoadingService } from './is-loading.service';

@Injectable({
  providedIn: 'root',
})
export class LiquidityBotService {
  constructor(
    @Inject(APP_CONFIG) private appConfig: any,
    private httpClient: HttpClient,
    private isLoadingService: IsLoadingService,
    private alertService: AlertService,
  ) {}

  public getBaseUrl(): string {
    return `${this.appConfig.tradingApiBaseUrl}/liquidity-bot`;
  }

  public async requestLiquidity(
    request: LiquidityBotRequest,
  ): Promise<boolean> {
    try {
      await this.isLoadingService.add(
        lastValueFrom(
          this.httpClient.post(`${this.getBaseUrl()}`, {
            chainId: request.chain.identifier,
            sellToken: request.sellAsset.token.address,
            buyToken: request.buyAsset.token.address,
            usdAmount: request.usdAmount,
          } as LiquidityBotRequestDto),
        ),
        { key: 'liquidity-bot' },
      );
      return true;
    } catch (error: any) {
      this.alertService.showError('liquidityBot.request.error');
      return false;
    }
  }

  public async requestLiquidityConditional(
    request: LiquidityBotRequestConditional,
  ): Promise<boolean> {
    try {
      await this.isLoadingService.add(
        lastValueFrom(
          this.httpClient.post(`${this.getBaseUrl()}/conditional`, {
            chainId: request.chain.identifier,
            sellToken: request.sellAsset.token.address,
            buyToken: request.buyAsset.token.address,
            usdAmount: request.usdAmount,
            expectedExecutionTimestamp: new Date(
              request.expectedExecutionTimestamp,
            ).toISOString(),
            triggerToken: request.triggerAsset.token.address,
            triggerCondition: request.triggerCondition,
            triggerPrice: request.triggerPrice,
          } as LiquidityBotRequestConditionalDto),
        ),
        { key: 'liquidity-bot' },
      );
      return true;
    } catch (error: any) {
      this.alertService.showError('liquidityBot.request.error');
      return false;
    }
  }
}
